import { app } from '../../app';

app.config(config);

/** @ngInject */
function config(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.spinnerTemplate = require('!html-loader!./spinner.html');
}



// WEBPACK FOOTER //
// ./src/portal/init/angular-loading-bar/angular-loading-bar.js